import script from "./RewardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardModal.vue?vue&type=script&setup=true&lang=js"

import "./RewardModal.vue?vue&type=style&index=0&id=756d9222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756d9222"]])

export default __exports__